import { defineMessages } from 'react-intl';

const MESSAGES = defineMessages({
  default: {
    id: 'ConfigurationDetail.error.default',
    defaultMessage: 'Your selected value isn\'t assignable, please check your input.',
  },
  cornerDesign: {
    id: 'ConfigurationDetail.WashBasinDimension.washbasinDimensions.error.cornerDesign.not_assignable',
    defaultMessage: 'Your selected value isn\'t assignable to selected type of installation.',
  },
  typeOfInstallation: {
    id: 'ConfigurationDetail.WashBasinDimension.washbasinDimensions.error.cornerDesign.not_assignable',
    defaultMessage: 'Your selected value isn\'t assignable, please check your type of installation.',
  },
  angleOfNiche: {
    id: 'ConfigurationDetail.WashBasinDimension.washbasinDimensions.error.cornerDesign.not_assignable',
    defaultMessage: 'Your selected value isn\'t assignable, please check your angle of niche.',
  },
  plateDimensions: {
    id: 'ConfigurationDetail.WashBasinDimension.washbasinDimensions.error.cornerDesign.not_assignable',
    defaultMessage: 'Your selected value isn\'t assignable, please check your plate dimensions.',
  },
  distancesInMM: { 
    id: 'ConfigurationDetail.WashBasinDimension.washbasinDimensions.error.cornerDesign.not_assignable',
    defaultMessage: 'Your selected value isn\'t assignable, please check your distances.',
  },
  apron: {
    id: 'ConfigurationDetail.WashBasinDimension.washbasinDimensions.error.cornerDesign.not_assignable',
    defaultMessage: 'Your selected value isn\'t assignable, please check your apron.',
  },
  surgeEdgeOrBackSplash: {
    id: 'ConfigurationDetail.WashBasinDimension.washbasinDimensions.error.cornerDesign.not_assignable',
    defaultMessage: 'Your selected value isn\'t assignable, please check your surge edge / back splash.',
  },
  tapHole: {
    id: 'ConfigurationDetail.WashBasinDimension.washbasinDimensions.error.cornerDesign.not_assignable',
    defaultMessage: 'Your selected value isn\'t assignable, please check your tap hole.',
  },
  soapDispenserHole: {
    id: 'ConfigurationDetail.WashBasinDimension.washbasinDimensions.error.cornerDesign.not_assignable',
    defaultMessage: 'Your selected value isn\'t assignable, please check your soap dispenser hole.',
  },
  paperTowelDispenserHole: {
    id: 'ConfigurationDetail.WashBasinDimension.washbasinDimensions.error.cornerDesign.not_assignable',
    defaultMessage: 'Your selected value isn\'t assignable, please check your paper towel dispenser hole.',
  },
  cosmeticTissueDispenser: {
    id: 'ConfigurationDetail.WashBasinDimension.washbasinDimensions.error.cornerDesign.not_assignable',
    defaultMessage: 'Your selected value isn\'t assignable, please check your cosmetic tissue dispenser.',
  },
  color: {
    id: 'ConfigurationDetail.WashBasinDimension.washbasinDimensions.error.cornerDesign.not_assignable',
    defaultMessage: 'Your selected value isn\'t assignable, please check your color.',
  },
  colorBottomSide: {
    id: 'ConfigurationDetail.WashBasinDimension.washbasinDimensions.error.cornerDesign.not_assignable',
    defaultMessage: 'Your selected value isn\'t assignable, please check your color bottom side.',
  },
});

export default MESSAGES;